// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vue-password-confirmation {
  display: flex;
  flex-direction: column;
  margin-inline: 6px;
  margin-block-end: 6px;
  gap: 10px 0;
}
.vue-password-confirmation__form {
  display: flex;
  flex-direction: column;
  gap: 8px 0;
  padding: 2px;
}
.vue-password-confirmation__submit {
  align-self: end;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/password-confirmation/dist/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;AACjB","sourcesContent":[".vue-password-confirmation {\n  display: flex;\n  flex-direction: column;\n  margin-inline: 6px;\n  margin-block-end: 6px;\n  gap: 10px 0;\n}\n.vue-password-confirmation__form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px 0;\n  padding: 2px;\n}\n.vue-password-confirmation__submit {\n  align-self: end;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
